




















































































































import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'
import {
  FavoriteList,
  FavoriteListCollection,
  IVendorPriceListEntry,
  Order,
  OrderEntry,
  PriceList,
  ReminderCollection
} from 'serverless-firestore'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import IconsMixin from '../../mixins/IconsMixin.vue'
import store, { Actions } from '../../store'

@Component({
  components: { LoadingPage }
})
export default class FavoriteListSelectionModal extends Mixins(IconsMixin, AuthMixin) {
  @Prop({ type: Object, default: null })
  public order!: Order

  public show: boolean = false
  public error: string = ''

  public isLoading: boolean = false
  public favoriteList: FavoriteList | null = null
  public priceLists: PriceList[] = []
  public selected: IVendorPriceListEntry[] = []
  public singleSelect = false

  // Filter Props
  public categoryFilter: string[] = []
  public categories: string[] = [
    'Beer',
    'Cocktail Mixes',
    'Hard Cider',
    'Bitters',
    'Wine',
    'Liquor & Spirits',
    'Whiskey',
    'Shochu & Soju',
    'Gin',
    'Brandy',
    'Liqueurs',
    'Vodka',
    'Absinthe',
    'Tequila',
    'Rum',
    'Flavored Alcoholic Beverages'
  ]
  public vendorFilter : { vendorCompanyId: string, vendorCompanyName: string }[] = []
  public vendorCompanyNames: { vendorCompanyId: string, vendorCompanyName: string }[] = []

  public search = ''
  public headers = [
    { text: '', sortable: false, value: 'icon' },
    { text: 'Description', value: 'description' },
    { text: 'Category', value: 'category' },
    { text: 'Vendor', value: 'vendor' },
    { text: 'Reminder', value: 'reminder' }
  ]

  public reminderMap: { [entryIdAndVendorId: string]: string[] } = { ['']: [''] }
  public companyNamesMap: { [entryIdAndVendorId: string]: string } = { ['']: '' }

  public $refs!: {
    form: HTMLFormElement
  }

  public get displayedEntries(): IVendorPriceListEntry[] {
    if (
      !this.favoriteList
      || !this.favoriteList.entries
      || !this.favoriteList.entries.length
    ) {
      return []
    }

    let entries = this.favoriteList.entries

    if (this.categoryFilter && this.categoryFilter.length) {
      entries = entries.filter(entry =>
        this.categoryFilter.includes(this.getCategory(entry))
      )
    }

    if (this.vendorFilter && this.vendorFilter.length) {
        entries = entries.filter(entry =>
        this.vendorFilter.find(e => e.vendorCompanyId === entry.vendorCompanyId)
      )
    }

    return entries
  }

  public async mounted() {
    this.isLoading = true
     try {
        let favoriteList = await this.lookupFavoriteList()
        if (!favoriteList) {
          favoriteList = new FavoriteList(this.userCompany.id)
        }

        this.favoriteList = favoriteList
        this.displayedEntries.forEach(entry => {
          if (entry.vendorCompanyName) {
            this.vendorCompanyNames.push(
              { vendorCompanyId: entry.vendorCompanyId, vendorCompanyName: entry.vendorCompanyName }
            )
          }
        })

        await this.setReminders()
      } catch (error) {
        const err = new Error('You do not have permissions to view that page')
        return store.dispatch(Actions.SET_ERROR, [err, this.$router])
      }
    this.isLoading = false
  }

  public hide() {
    this.show = false
  }

  public toggle(clickedProduct: any) {
    const productIndex = this.selected.findIndex(sel => sel === clickedProduct)
    if (productIndex >= 0) {
      this.selected.splice(productIndex, 1)
    } else {
      this.selected.push(clickedProduct)
    }
  }

  public getCategory(entry: IVendorPriceListEntry) {
    if(!entry || !entry.category) {
      return 'N/A'
    }

    const lineageArray = entry.category.split(' > ')
    return lineageArray[lineageArray.length - 1].trim()
  }

  public getReminders(reminders: string[]) {
    if(!reminders || !reminders.length) {
      return 'N/A'
    }

    const remindersString = reminders.reduce((acc, reminder) => {
      if(!reminder || !reminder.length) {
        return acc
      } else if (!acc || !acc.length) {
        return reminder
      } else {
        return `${acc}, ${reminder}`
      }
    }, '')
    return remindersString
  }

  private async setReminders(){
    const reminderCollection = new ReminderCollection(( await this.$firebase ).firestore());
    const reminders = await reminderCollection.listRemindersByRestaurantCompanyId(this.userCompany.id)
    reminders.forEach(reminder => {
      if (
        this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId]
        && !this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId].includes(reminder.text)
      ) {
        this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId].push(reminder.text)
      } else if (!this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId]) {
        this.reminderMap[reminder.priceListEntryId + reminder.vendorCompanyId] = [reminder.text]
      }
    })
  }

  private async lookupFavoriteList() {
    const favoriteListCollection = new FavoriteListCollection(( await this.$firebase ).firestore())
    return await favoriteListCollection.findFavoriteListByRestaurant(this.userCompany.id)
  }

  public async confirmSave() {
    const selectedOrderEntries: OrderEntry[] = this.selected.map(selectedEntry => {
      const orderEntry: OrderEntry = new OrderEntry(selectedEntry.upc, selectedEntry.description)
      orderEntry.category = selectedEntry.category
      orderEntry.quantity = 1
      orderEntry.vendorCompanyId = selectedEntry.vendorCompanyId
      orderEntry.priceListId = selectedEntry.priceListId
      orderEntry.priceListEntryId = selectedEntry.id
      return orderEntry
    })
    this.order.orderEntries.unshift(...selectedOrderEntries)

    this.hide()
  }
}
